import {
  Flex,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
} from "@chakra-ui/react";
import { FaCheck } from "react-icons/fa";
import { PricingTableProps } from "./pricing-table";
import { Fragment } from "react";

export const DesktopPricingTable = ({
  pricingOptions,
  pricingPlans,
  pricingTableRows,
}: PricingTableProps) => {
  return (
    <TableContainer
      border="1px solid black"
      borderBottom="none"
      borderRadius="lg"
    >
      <Table
        size={{
          base: "small",
          sm: "md",
        }}
      >
        <Thead>
          <Tr bgColor={"#DDEAFF"}>
            <Th
              border="1px solid black"
              borderTop="none"
              borderLeft="none"
            ></Th>
            {pricingPlans.map((plan, idx) => (
              <Th
                key={`desktop-pricing-table-head-${idx}`}
                border="1px solid black"
                borderTop="none"
                borderRight={idx === 1 ? "none" : ""}
                px={3}
              >
                <VStack>
                  <Text
                    color="#0284C7"
                    textTransform="capitalize"
                    fontSize={{
                      base: 12,
                      md: 16,
                    }}
                    fontWeight="extrabold"
                    pb={{ md: idx !== 0 ? 2 : 0 }}
                    pt={3}
                    mt={idx === 0 ? 0.8 : 0}
                  >
                    {plan.planName}
                  </Text>
                  {idx === 0 ? (
                    <Flex
                      flexDir={"row"}
                      alignItems={"center"}
                      gap={2}
                      filter={`${plan.planName === "Pro" ? "blur(7px)" : ""}`}
                    >
                      <Text
                        textTransform="capitalize"
                        color="black"
                        fontSize={28}
                        fontWeight="extrabold"
                      >
                        {pricingOptions[`${idx}`].price}
                      </Text>
                      <Flex
                        textTransform="lowercase"
                        flexDir="column"
                        fontWeight="medium"
                        fontSize={13}
                      >
                        <Text pr={0}>per</Text>
                        <Text>report</Text>
                      </Flex>
                    </Flex>
                  ) : (
                    <Text
                      textTransform="capitalize"
                      color="black"
                      fontSize={28}
                      fontWeight="extrabold"
                      pb={2}
                    >
                      {pricingOptions[`${idx}`].price}
                    </Text>
                  )}
                  <Text
                    textTransform="none"
                    fontWeight="medium"
                    fontStyle="italic"
                    color="#1d4ed8"
                    fontSize={13}
                    lineHeight={1.5}
                    textAlign="center"
                    maxW={"210px"}
                    whiteSpace="pre-line"
                  >
                    {plan.tableSubtitle}
                  </Text>
                </VStack>
              </Th>
            ))}
          </Tr>
        </Thead>
        <Tbody fontSize={16}>
          {pricingTableRows.slice(0, 3).map((row, rowIdx) => (
            <Tr key={`desktop-pricing-table-row-${rowIdx}`}>
              <Td border="1px solid black" borderLeft="none">
                {row?.rowName}
              </Td>
              {Object.values(row)
                .slice(1)
                .map((content: string, cellIdx) => (
                  <Fragment key={`desktop-pricing-table-cell-${cellIdx}`}>
                    {content && (
                      <Td
                        border="1px solid black"
                        textAlign="center"
                        borderRight={cellIdx === 2 ? "none" : ""}
                        borderLeft={cellIdx === 0 ? "none" : ""}
                        filter={`${
                          cellIdx === 1 && rowIdx === 2 ? "blur(7px)" : ""
                        }`}
                      >
                        {content}
                      </Td>
                    )}
                  </Fragment>
                ))}
            </Tr>
          ))}
          {pricingTableRows.slice(3).map((row, rowIdx) => (
            <Tr key={`desktop-pricing-table-row-${rowIdx}`}>
              <Td border="1px solid black" borderLeft="none">
                {row.rowName}
              </Td>
              {Object.values(row)
                .slice(1)
                .map((content: boolean, cellIdx) => (
                  <Fragment key={`desktop-pricing-table-cell-${cellIdx}`}>
                    {content !== null && (
                      <Td
                        border="1px solid black"
                        borderRight={cellIdx === 2 ? "none" : ""}
                        borderLeft={cellIdx === 0 ? "none" : ""}
                      >
                        <Flex justifyContent="center">
                          {content ? <FaCheck /> : <></>}
                        </Flex>
                      </Td>
                    )}
                  </Fragment>
                ))}
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};
